import { Link } from "react-router-dom";
import { Gem, Users } from "lucide-react";
import Navbar from "../components/Navbar";

const WAYS = [
  {
    Icon: Gem,
    title: "Collectors & Sellers",
    text: "If you have an eye for vintage and a collection worth sharing, join us and we'll digitize your collection and add it to our archive. You'll earn commission on each try-on and reach customers who truly appreciate what you've got.",
  },
  {
    Icon: Users,
    title: "Creators & Brands",
    text: "Partner on campaigns, drops and content that celebrate authentic vintage fashion and the world of virtual try-on.",
  },
];

export default function Collab() {
  return (
    <div className="relative z-10 min-h-screen bg-[#FDFBF7]">
      <Navbar />
      <div className="px-6 md:px-16 py-16 md:py-24 max-w-4xl mx-auto" data-testid="collab-page">
        <p className="text-xs uppercase tracking-[0.4em] text-[#8B5A2B] text-center mb-6">Collab</p>
        <h1 className="font-serif-display text-4xl md:text-5xl leading-tight text-center mb-6">
          Let's Make Something Vintage.
        </h1>
        <p className="text-center text-[#4A4A4A] max-w-2xl mx-auto mb-14 leading-relaxed">
          Vintage Identity partners with collectors, sellers and creators who love authentic
          vintage as much as we do. If that's you, we'd love to collaborate. Join our growing
          archive and the mission to be the world's largest vintage virtual try-on.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-14 max-w-3xl mx-auto">
          {WAYS.map((w) => (
            <div
              key={w.title}
              data-testid={`collab-card-${w.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className="rounded-2xl border border-[#1A1A1A]/10 bg-[#F4F1EA] p-7 text-center flex flex-col items-center"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-full bg-[#6D214F]/10 text-[#6D214F] mb-4">
                <w.Icon className="w-5 h-5" strokeWidth={1.6} />
              </span>
              <h3 className="font-serif-display text-2xl mb-3">{w.title}</h3>
              <p className="text-sm text-[#4A4A4A] leading-relaxed">{w.text}</p>
            </div>
          ))}
        </div>

        <div className="text-center">
          <Link
            to="/try-on"
            data-testid="collab-cta"
            className="inline-flex items-center justify-center bg-[#1A1A1A] text-[#FDFBF7] text-xs uppercase tracking-[0.2em] px-8 py-3.5 rounded-full hover:bg-[#6D214F] transition-colors duration-300"
          >
            Get in Touch
          </Link>
        </div>
      </div>
    </div>
  );
}
